module.exports = __webpack_public_path__ + "assets/img/vtuber-app1.d56e8986.png";